import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import Vue from "vue";

import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { User } from "@/modules/users/viewmodels/User";

// state
export const state = {
  users: [],
  current: {},
  currentStatus: false,
};

export const getters = Object.assign(
  {
    users: (state) => {
      return state.users;
    },
    current: (state) => {
      return state.current;
    },
    currentStatus: (state) => {
      return state.currentStatus;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/users",
    User,
    {
      AfterGetAll: (name, data) => {
        state.users = data;
        return data;
      },
      AfterShow: (name, data) => {
        let el = state.users.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.users.push(data);
        }
        return data;
      },
      AfterDestroy: (name, data) => {
        let elementIndex = state.users.findIndex((e) => e.id === data);

        if (elementIndex !== null) {
          state.users.splice(elementIndex, 1);
        }

        return data;
      },
    },
    {
      /**
       * Returns user with id
       * this.$store.getters['user/api'].Custom.User(id)
       */
      User: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/users/" + Id,
          {}
        );
        let data = new User(ApiResult.data.data);

        return data;
      },

      /**
       * Returns the curent user
       * this.$store.getters['user/api'].Custom.Current()
       */
      Current: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/users/current",
          {}
        );

        let data = new User(ApiResult.data.data);

        return data;
      },

      /**
       * Returns the curent user
       * this.$store.getters['user/api'].Custom.Search()
       */
      Search: async (Data) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/users/search",
          { params: { search: Data.search } }
        );

        let data = ApiResult.data.data.map((e) => {
          return new User(e);
        });

        return data;
      },

      /**
       * Generate password for user
       * this.$store.getters['user/api'].Custom.GeneratePassword()
       */
      GeneratePassword: async (UserId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL +
            "/api/users/" +
            UserId +
            "/generate-password",
          {},
          {}
        );
        return ApiResult.data.data;
      },

      /**
       * Update the current user
       * this.$store.getters['user/api'].Custom.UpdateCurrent(UserData, QueryStringParameter)
       */
      UpdateCurrent: async (Data, Params) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.put(
          process.env.VUE_APP_BASE_URL + "/api/users/current",
          Data,
          { params: Params ? Params : {} }
        );

        let data = new User(ApiResult.data.data);

        return data;
      },

      /**
       * Update the current user status
       * this.$store.getters['user/api'].Custom.Current(IsOnline)
       */
      UpdateCurrentStatus: async (Online) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.put(
          process.env.VUE_APP_BASE_URL + "/api/users/current-status",
          {
            online: Online ? Online : false,
          },
          {}
        );

        let data = ApiResult.data.data.map((Entry) => {
          return new User(Entry);
        });

        return data;
      },

      /**
       * Update the current user avatar
       * this.$store.getters['users/api'].Custom.UpdateCurrentAvatar(Avatar)
       */
      UpdateCurrentAvatar: async (Avatar) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users/current-avatar",
          {
            filename: Avatar.filename,
          },
          {}
        );

        let data = new User(ApiResult.data.data);

        return data;
      },

      /**
       * Delete the current user
       * this.$store.getters['users/api'].Custom.DeleteCurrent(YourPassword)
       */
      DeleteCurrent: async (YourPassword) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users/current-delete",
          {
            password: YourPassword ? YourPassword : null,
          },
          {}
        );
        return ApiResult.data.data;
      },

      /**
       *
       * this.$store.getters['users/api'].Custom.RefreshCurrent()
       */
      RefreshCurrent: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/users/current-refresh",
          {},
          {}
        );
        return ApiResult.data.data;
      },

      /**
       * Lock an user
       * this.$store.getters['users/api'].Custom.Lock(UserId)
       */
      Lock: async (UserId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users/" + UserId + "/lock",
          {},
          {}
        );
        return ApiResult.data.data;
      },

      /**
       * Lock an user
       * this.$store.getters['users/api'].Custom.Unlock(UserId)
       */
      Unlock: async (UserId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users/" + UserId + "/unlock",
          {},
          {}
        );
        return ApiResult.data.data;
      },

      /**
       * Lock an user
       * this.$store.getters['users/api'].Custom.Lock(UserId)
       */
      Block: async (UserId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users/" + UserId + "/block",
          {},
          {}
        );
        return ApiResult.data.data;
      },

      /**
       * Unblock an user
       * this.$store.getters['users/api'].Custom.Unblock(UserId)
       */
      Unblock: async (UserId) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/users/" + UserId + "/unblock",
          {},
          {}
        );
        return ApiResult.data.data;
      },
    }
  )
);

// mutations
export const mutations = {
  setUser: (state, value) => {
    state.current = Object.assign({}, value);
    // Vue.set(state, "current", value);
    return state.current;
  },
  setStatus: (state, value) => {
    state.currentStatus = value;
    return state.currentStatus;
  },
  setAvatar: (state, value) => {
    state.current.avatar = value;
    return state.current;
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/users",
  [],
  {
    /**
     * Set the user store
     * @param {*} param0
     * @param {*} payload
     */
    setUser({ commit, dispatch }, payload) {
      commit("setUser", payload);
    },
    /**
     * Update the current user
     * @param {*} param0
     * @param {*} formData
     */
    updateCurrent({ commit, dispatch }, formData) {
      httpAxios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token") !== null
          ? `Bearer ${localStorage.getItem("token")}`
          : "";
      return new Promise((resolve, reject) => {
        httpAxios
          .put("/api/users/current", formData)
          .then((response) => {
            resolve(response.data);
          })
          .catch(function(error) {
            let message = Vue.i18n.translate(
              "Es ist eine Fehler bei einer Datenbankabfrage gekommen."
            );
            if (process.env.NODE_ENV === "development") {
              message = error;
            }
            reject(message);
          });
      });
    },
    /**
     * Update the current status of a user user
     * @param {*} param0
     * @param {*} formData
     */
    updateCurrentStatus({ commit, dispatch }, online) {
      httpAxios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token") !== null
          ? `Bearer ${localStorage.getItem("token")}`
          : "";
      commit("setStatus", online ? online : false);

      return new Promise((resolve, reject) => {
        httpAxios
          .put("/api/users/current-status", { online: online ? online : false })
          .then((response) => {
            resolve(response.data);
          })
          .catch(function(error) {
            let message = Vue.i18n.translate(
              "Es ist eine Fehler bei einer Datenbankabfrage gekommen."
            );
            if (process.env.NODE_ENV === "development") {
              message = error;
            }
            reject(message);
          });
      });
    },
    /**
     * Change the password for the current user
     * @param {*} param0
     * @param {*} formData
     */
    updateCurrentPassword({ commit, dispatch }, formData) {
      httpAxios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token") !== null
          ? `Bearer ${localStorage.getItem("token")}`
          : "";
      return new Promise((resolve, reject) => {
        httpAxios
          .put("/api/users/current-password", formData)
          .then((response) => {
            resolve(response.data);
          })
          .catch(function(error) {
            let message =
              error.response.data.data !== undefined &&
              error.response.data.data.message !== undefined
                ? error.response.data.data.message
                : "";
            reject(message);
          });
      });
    },
    /**
     * Delete the current user
     * @param {*} param0
     * @param {*} formData
     */
    deleteCurrent({ commit, dispatch }, formData) {
      httpAxios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token") !== null
          ? `Bearer ${localStorage.getItem("token")}`
          : "";
      return new Promise((resolve, reject) => {
        httpAxios
          .post("/api/users/current-delete", formData)
          .then((response) => {
            resolve(response.data);
          })
          .catch(function(error) {
            let message =
              error.response.data.data !== undefined &&
              error.response.data.data.message !== undefined
                ? error.response.data.data.message
                : "";
            reject(message);
          });
      });
    },
  }
);
